module.exports = __webpack_public_path__ + "media/images/features/3/studio-3-6884daa3178448e6dd6d239399c89b34.jpg";